import { withNewPassword } from '../../password';

/** The new invitee's password; the invitation's code comes from the link itself. */
export const joinOrganizationSchema = withNewPassword({});
